import { Box, Link } from '@mui/material';

function Social() {
  return (
    <Box
      display="flex"
      justifyContent="center"
      gap={2}
      sx={{
        fontSize: '0.95rem',
      }}
    >
      <Link
        href="https://www.linkedin.com/in/rojan-thomas/"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          color: 'text.primary',
          textDecoration: 'none',
          borderBottom: '1px solid',
          borderColor: 'divider',
          '&:hover': {
            borderColor: 'text.primary',
            opacity: 0.7,
          },
        }}
      >
        LinkedIn
      </Link>
      <Box component="span" sx={{ color: 'text.secondary' }}>|</Box>
      <Link
        href="https://github.com/rojanthomas"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          color: 'text.primary',
          textDecoration: 'none',
          borderBottom: '1px solid',
          borderColor: 'divider',
          '&:hover': {
            borderColor: 'text.primary',
            opacity: 0.7,
          },
        }}
      >
        GitHub
      </Link>
      <Box component="span" sx={{ color: 'text.secondary' }}>|</Box>
      <Link
        href="https://www.instagram.com/rojansthomas/"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          color: 'text.primary',
          textDecoration: 'none',
          borderBottom: '1px solid',
          borderColor: 'divider',
          '&:hover': {
            borderColor: 'text.primary',
            opacity: 0.7,
          },
        }}
      >
        Instagram
      </Link>
    </Box>
  )
}

export default Social;
